import { initAuth, logout } from "@/auth/keycloak"
import { createCustomer, getClickId } from "@/api/tapfiliate.api"
import store from "./store/store"
import { trackGtmEvent } from "@/services/GtmService"

// Tapfiliate referral tracking — best-effort. Wrapped so a referral/Tapfiliate
// failure can never block app boot.
const trackReferral = async (user) => {
  try {
    const referralCode = localStorage.getItem("referral_code")

    if (!referralCode) {
      return
    }

    const clickId = await getClickId(referralCode)

    if (!clickId) {
      return
    }

    await createCustomer(clickId, user.email, {
      id: user.id,
      email: user.email,
      first_name: user.basic_info.first_name,
      last_name: user.basic_info.last_name,
    })

    localStorage.removeItem("referral_code")
  } catch (e) {
    console.error("[BOOT] Referral tracking failed", e)
  }
}

// App boot, run once Keycloak has initialized. Mounts the app only after the
// user is loaded; a mid-session 401 is recovered by the toolsClient interceptor.
const onReady = async (authenticated) => {
  if (!authenticated) {
    await logout()
    return
  }

  try {
    const user = await store.dispatch("Profile/fetchUser", {}, { root: true })

    trackGtmEvent({
      event: "user_authenticated",
      user_id: user.id,
    })

    await trackReferral(user)

    // ./bootstrap registers global components and mounts the Vue app.
    require("./bootstrap")
  } catch (e) {
    console.error("[BOOT] Failed to load user", e)
  }
}

initAuth(onReady).catch((e) => {
  console.error("[BOOT] Keycloak init failed", e)
})
